<template>
    <div class="filter_container">
        <h5 style="padding:10px 0px;">銷售管理報表</h5>
        <div class="filter">
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                v-model="start_at"
                placeholder="開始日期"
                format="YYYY-MM-DD"
            >
            </date-picker>
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                placeholder="結束日期"
                v-model="end_at"
                format="YYYY-MM-DD"
            >
            </date-picker>

            <span style="display:inline-block; width: 100px;margin-right:3px;">
                <select style="width:100%; height: 34px;" v-model="selected_is_open" v-if="mode === 'admin' || mode === 'supplier'" @change="getData">
                    <option v-for="(item, idx) in is_open_items" :key="idx" :value="item.value">
                        {{item.text}}
                    </option>
                </select>
            </span>

            <span style="display:inline-block; width: 350px;margin-right:3px;">
                <select style="width:100%; height: 34px;" v-model="selected_project" v-if="mode !== 'admin' || is_show_refund_detail === true"  @change="getData">
                    <option selected value="">全部課程</option>
                    <option v-for="(product, idx) in products" :key="idx" :value="product.value">
                        {{product.text}}
                    </option>
                </select>
            </span>

            <b-button
                v-on:click="getData()"
            >
                取得資料
            </b-button>

        </div>

        <div></div>

        <div style="width: 100%;margin-top:1em;">
            <b-card no-body >
                <b-tabs card>

                    <!-- 退票詳細分頁  -->
                    <b-tab v-if="is_show_refund_detail" :title="selected_supplier.name  + '詳細退票數據'" active>
                        <b-card-text>
                            <div style="display:flex; flex-direction:row;align-items: center;">
                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="cancel_detail.chart_view"
                                        />
                                    </div>
                                </div>

                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item v-for="(item ,idx) in cancel_detail.total_view" :key="idx">
                                            <span class="float-left">{{ total_view_mapper[item.key] }}：</span>
                                            <span class="float-right mr-2">{{ item.value }}</span>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>

                            <div>
                                <b-table
                                    sticky-header="500px"
                                    style="margin-top:1em;"
                                    :items="cancel_detail.table_view['items']" :fields="cancel_detail.table_view['columns']"
                                >
                                </b-table>
                            </div> 
                        </b-card-text>
                    </b-tab>




                    <b-tab v-if="selected_supplier !== null && (mode === 'supplier' || mode === 'store')" :title="selected_supplier.name" :active="selected_supplier !== null && selected_store === null" @click="back('supplier')">
                        <b-card-text>
                            <div style="display:flex; flex-direction:row;align-items: center;">
                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="chart_view[mode]"
                                        />
                                    </div>
                                </div>

                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item v-for="(item ,idx) in total_view[mode]" :key="idx">
                                            <span class="float-left">{{ total_view_mapper[item.key] }}：</span>
                                            <span v-if="item.key === 'total_avg_score'" class="float-right mr-2">{{ item.value.toFixed(2) }}</span>
                                            <span v-else class="float-right mr-2">{{ item.value }}</span>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>

                            <div>
                                <b-table
                                    sticky-header="500px"
                                    style="margin-top:1em;"
                                    :items="table_view[mode]['items']" :fields="table_view[mode]['columns']"
                                >
                                    <template v-slot:head()="data">
                                        <span 
                                            v-b-tooltip.hover :title="data.field.tooltip"
                                        >
                                            {{ data.label }}
                                            <i  
                                                v-if="data.field.tooltip !== undefined" 
                                                class="bi bi-info-circle">
                                            </i>
                                        </span>
                                    </template>

                                    <template v-slot:cell(name)="{ item }">
                                        <span 
                                            style="color: #68acef; cursor:pointer;"
                                            @click="goStore(item)"
                                        >
                                            {{item.name}}
                                        </span>
                                    </template>

                                    <template v-slot:cell(is_open)="{ item }">
                                        <span 
                                            class="status"
                                            :class="{
                                               'open_status': item.is_open === 1,
                                               'close_status': item.is_open === 0,
                                            }"
                                        >
                                            {{getOpenStatus(item.is_open)}}
                                        </span>
                                    </template>


                                    <template 
                                        v-slot:cell(avg_score)="{ item }"
                                    >
                                        <span 
                                            @click="goScore(mode, item)"
                                            style="color:#3a8bdb; cursor: pointer;text-decoration: underline;"
                                        >
                                            {{item.avg_score}}
                                        </span>
                                    </template>

                                </b-table>
                            </div> 
                        </b-card-text>
                    </b-tab>


                    <b-tab v-if="selected_store !== null" :title="selected_store.name" :active="selected_store !== null && selected_supplier !== null">
                        <b-card-text>
                            <div style="display:flex; flex-direction:row;align-items: center;">
                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="chart_view[mode]"
                                        />
                                    </div>
                                </div>

                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item v-for="(item ,idx) in total_view[mode]" :key="idx">
                                            <span class="float-left">{{ total_view_mapper[item.key] }}：</span>
                                            <span v-if="item.key === 'total_avg_score'" class="float-right mr-2">{{ item.value.toFixed(2) }}</span>
                                            <span v-else class="float-right mr-2">{{ item.value }}</span>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>

                            <div>
                                <b-table
                                    sticky-header="500px"
                                    style="margin-top:1em;"
                                    :items="table_view[mode]['items']" :fields="table_view[mode]['columns']"
                                >
                                    <template v-slot:head()="data">
                                        <span 
                                            v-b-tooltip.hover :title="data.field.tooltip"
                                        >
                                            {{ data.label }}
                                            <i  
                                                v-if="data.field.tooltip !== undefined" 
                                                class="bi bi-info-circle">
                                            </i>
                                        </span>
                                    </template>

                                    <template 
                                        v-slot:cell(avg_score)="{ item }"
                                    >
                                        <span 
                                            @click="goScore(mode, item)"
                                            style="color:#3a8bdb; cursor: pointer;text-decoration: underline;"
                                        >
                                            {{item.avg_score.toFixed(2)}}
                                        </span>
                                    </template>

                                </b-table>
                            </div> 
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>    
<script>

    import { 
        apiGetProductPerformanceView,
        apiGetCancelDetail
    } from '@/api/Merchant.js'

    import {
        apiGetTicketProjectList,
        apiGetMerchantById,
        apiGetStoreById
    } from '@/api/AdminManage.js'

    // 當然是要用別人做好的輪子！
    
    // 載入中視窗
    import loading from 'vue-full-loading'

    // 日期選擇器
    import 'vue2-datepicker/locale/zh-cn';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    // 圖表套件
    import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    )

    export default {
        components: { DatePicker, loading, LineChartGenerator},
        name: 'SalesReport',
        data: function() {
            return {
                start_at: new Date(new Date().setDate(new Date().getDate() - 7)),
                end_at: new Date(),
                mode: 'supplier',
                selected_supplier: null,
                selected_store: null,
                selected_project: null,
                products : [],

                lang: {
                    placeholder: {
                        date: '選擇日期'
                    }
                },
                loading_config: {
                    "show": true,
                    "label": '載入資料中'
                },
                chart_view: {
                    admin: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#f87979',
                                data: [40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    },
                    supplier: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#f87979',
                                data: [40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    },
                    store: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#f87979',
                                data: [40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    }
                },
                table_view: {
                    admin: {
                        columns: [
                            {
                                label: '供應商名稱',
                                key: 'name'
                            },
                            {
                                label: '銷售數',
                                key: 'sale',
                                sortable: true,
                            },
                            {
                                label: '使用數',
                                key: 'use',
                                sortable: true,
                            },
                            {
                                label: '退票數',
                                key: 'refund',
                                sortable: true,
                            },
                            {
                                label: '退票率',
                                key: 'refund_rate',
                                tooltip: '退票數 / 銷售數',
                                sortable: true,
                            },
                            {
                                label: '評價',
                                key: 'avg_score',
                                sortable: true,
                            },
                        ],
                        items:[],
                    },
                    supplier: {
                        columns: [
                            {
                                label: '分店名稱',
                                key: 'name'
                            },
                            {
                                label: '服務狀態',
                                key: 'is_open',
                                sortable: true,
                            },
                            {
                                label: '使用數',
                                key: 'use',
                                sortable: true,
                            },
                            {
                                label: '評價',
                                key: 'avg_score',
                                sortable: true,
                            },
                        ],
                        items:[],
                    },
                    store: {
                        columns: [
                            {
                                label: '課程名稱',
                                key: 'name'
                            },
                            {
                                label: '使用數',
                                key: 'use',
                                sortable: true,
                            },
                            {
                                label: '評價',
                                key: 'avg_score',
                                sortable: true,
                            },
                        ],
                        items:[],
                    }
                },
                total_view: {
                    admin: [],
                    supplier: [],
                    store: [],
                },
                cancel_detail: {
                    chart_view: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#f87979',
                                data: [40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    },
                    table_view: {
                        items: [],
                        columns: [
                            {
                                label: '課程名稱',
                                key: 'product_name',
                                sortable: true
                            },
                            {
                                label: "3T",
                                key:"3t",
                                sortable: true
                            },
                            {
                                label: "Buty99",
                                key:"buty99",
                                sortable: true
                            },
                            {
                                label: "Line酷券",
                                key:"line",
                                sortable: true
                            },
                            {
                                label: "蝦皮",
                                key:"shopee",
                                sortable: true
                            },
                            {
                                label: "yahoo",
                                key:"yahoo",
                                sortable: true
                            },
                            {
                                label: "shopping99",
                                key:"shopping99",
                                sortable: true
                            },
                        ],
                    },
                    total_view: [],
                },
                total_view_mapper: {
                    total_avg_score: "評價",
                    total_refund: "退票數",
                    total_sale: "銷售數",
                    total_use: "使用數",
                    "3t": "3T",
                    "buty99": "Buty99",
                    "line": "Line酷券",
                    "shopee": "蝦皮",
                    "yahoo": "yahoo",
                    "shopping99": "shopping99"
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },
                text: {
                    total_success_text: '完成預約數',
                    total_fail_text: '未完成預約數',
                    total_total_text: '預約總數',
                    total_wait_text: '平均預約處理時間',
                    total_done_text: '平均到店服務時間',
                },
                chart_colors: [
                    '#ff6384', '#35a2eb', '#fed369', '#4bc0c0', '#9966ff', '#c8cbcf'
                ],
                is_show_refund_detail: false,
                is_open_items: [
                    {
                        "text": "服務中",
                        "value": 1,
                    },
                    {
                        "text": "關閉中",
                        "value": 0,
                    },
                    {
                        "text": "全部顯示",
                        "value": "",
                    },
                ],
                selected_is_open: "",
                merchant_session: JSON.parse(localStorage.getItem('merchant_session'))        
            }
        },
        methods: {
            getData: async function(){
                
                // 如果查退貨資料的話，轉到取退貨API
                console.log(this.is_show_refund_detail)
                if (this.is_show_refund_detail) {
                    this.getRefundDetailData(this.selected_supplier)
                    return
                }     

                if (this.getQueryVariable('report_type') === 'refund') {
                    this.selected_supplier = {
                        id: this.getQueryVariable('supplier_id'),
                        name: await this.getSupplierNameById(this.getQueryVariable('supplier_id'))
                    }
                    await this.getRefundDetailData(this.selected_supplier)
                    this.is_show_refund_detail = true
                    return
                }

                let param;
                let that = this
                let new_url = window.location.href
                new_url = this.appendParamToUrl(
                    new_url, 'start_at', this.$bus.getYYYYMMDD(this.start_at, '-')
                )
                new_url = this.appendParamToUrl(
                    new_url, 'end_at', this.$bus.getYYYYMMDD(this.end_at, '-')
                )
                window.history.pushState('', document.title, new_url);
                console.log(new_url);
                // 取銷售資料
                if (this.merchant_session['is_super_manage'] === 0) {
                    param = {
                        start_at : this.$bus.getYYYYMMDD(this.start_at, '-') ,
                        end_at: this.$bus.getYYYYMMDD(this.end_at, '-'),
                        mode: this.mode,
                        supplier_id: this.merchant_session['supplier_id'],
                        store_id: this.merchant_session['store_id']
                    }
                } else {
                    param = {
                        start_at : this.$bus.getYYYYMMDD(this.start_at, '-') ,
                        end_at: this.$bus.getYYYYMMDD(this.end_at, '-'),
                        mode: this.mode,
                        supplier_id: this.merchant_session['supplier_id']
                    }
                }
                

                do {
                    // if (!this.getQueryVariable('supplier_id') && !this.getQueryVariable('store_id')) {
                    //     console.log("1");
                    //     this.mode = 'admin'
                    //     param.mode = 'admin'
                    //     break;
                    // }
                    if (this.getQueryVariable('supplier_id') && !this.getQueryVariable('store_id')) {
                        console.log("2");
                        this.mode = 'supplier'
                        param.mode = 'supplier'
                        param['supplier_id'] = this.getQueryVariable('supplier_id')
                        // if (!this.selected_supplier) {
                        //     console.log("612");
                        //     this.selected_supplier = {
                        //         id: this.getQueryVariable('supplier_id'),
                        //         name: await this.getSupplierNameById(this.getQueryVariable('supplier_id'))
                        //     }
                        // }
                        await this.getProducts(this.getQueryVariable('supplier_id'))
                        break;
                    }
                    if (this.getQueryVariable('supplier_id') && this.getQueryVariable('store_id')) {
                        console.log("3");
                        this.mode = 'store'
                        param.mode = 'store'
                        param['supplier_id'] = this.getQueryVariable('supplier_id')
                        param['store_id'] = this.getQueryVariable('store_id')
                        // if (!this.selected_supplier) {
                        //     console.log("628");
                        //     this.selected_supplier = {
                        //         id: this.getQueryVariable('supplier_id'),
                        //         name: await this.getSupplierNameById(this.getQueryVariable('supplier_id'))
                        //     }
                        // }
                        // if (!this.selected_store) {
                        //     console.log('635');
                        //     this.selected_store = {
                        //         id: this.getQueryVariable('store_id'),
                        //         name: await this.getStoreNameById(this.getQueryVariable('store_id'))
                        //     }
                        // }
                        await this.getProducts(this.getQueryVariable('supplier_id'))
                        break;
                    }
                }while(0)

                if (this.getQueryVariable('product_id')) {
                    param['product_id'] = this.getQueryVariable('product_id')
                }
                console.log(this.selected_project)
                if (this.selected_project) {
                    param['product_id'] = this.selected_project
                }

                if (this.selected_is_open !== '') {
                    param['is_open'] = this.selected_is_open
                }
                console.log('725行',param);
                apiGetProductPerformanceView(param).then(function(resp){
                    let data = resp.data.data
                    console.log(data)
                    data.chart_view.datasets.forEach(function(dataset, idx){
                        dataset['backgroundColor'] = that.chart_colors[idx]
                        dataset['borderColor'] = that.chart_colors[idx]
                    })
                    console.log('?')
                    console.log(that.mode);
                    that.chart_view[that.mode] = data.chart_view
                    that.table_view[that.mode]['items'] = data.table_view
                    let keys = Object.keys(data.total_view)
                    console.log(keys);
                    that.total_view[that.mode] = keys.map(function(key){
                        let tmp = {
                            key : key,
                            value: data.total_view[key]
                        }
                        return tmp 
                    })
                    console.log(that.total_view)

                }).catch(function(error){
                    console.log(error)
                    let data = error.response.data
                    console.log(data)
                    if (data.ok === 0) {
                        that.$bus.fnShowInfo(data.msg)
                        return
                    }
                })
            },
            getProducts: function(supplier_id){
                let that = this
                let param = {
                    // search_start_date: this.$bus.getYYYYMMDD(this.start_at, '-'),
                    // search_end_date: this.$bus.getYYYYMMDD(this.end_at, '-'),
                    supplier_id: supplier_id,
                    keyword: '',
                }
                apiGetTicketProjectList(param).then(function(resp){
                    let data = resp.data
                    console.log(data)
                    let project_list = data.data.ticket_project_list

                    that.products = project_list.map(function(project){
                        
                        let tmp = {
                            text: project.ticket_project_name,
                            value: project.product_id
                        }

                        if (project.ns_item_id !== '') {
                            tmp.value = project.ns_item_id
                        }

                        return tmp 
                    })
                    console.log('that.products',that.products)

                }).catch(function(error){
                    console.log(error)
                    let data = error.response.data
                    console.log(data)
                    if (data.ok === 0) {
                        alert(data.msg)
                        return
                    }
                })
            },
            formatRate: function(rate){
                return (rate * 100).toFixed(2) + '%'
            },
            goSupplier: async function(supplier) {
                console.log(supplier);
                console.log('supplier');
                this.mode = 'supplier'
                this.selected_supplier = supplier
                let new_url = this.appendParamToUrl(window.location.href, 'supplier_id', supplier.id)
                window.history.pushState('', document.title,new_url);
                await this.getData()
                await this.getProducts(supplier.id)
            },
            goStore: async function(store) {
                console.log(store);
                console.log(this.selected_supplier);
                console.log('store');
                //this.selected_supplier = null;
                this.selected_store = store
                this.mode = 'store'
                console.log(this.selected_store);
                let new_url = this.appendParamToUrl(window.location.href, 'store_id', store.id)
                window.history.pushState('', document.title,new_url);
                await this.getData()
            },
            goRefundDetail: async function(supplier) {
                this.is_show_refund_detail = true;
                this.selected_supplier = supplier
                let new_url = this.appendParamToUrl(window.location.href, 'report_type', 'refund')
                new_url = this.appendParamToUrl(new_url, 'supplier_id', this.selected_supplier.id)
                window.history.pushState('', document.title,new_url);
                await this.getRefundDetailData(this.selected_supplier)
                await this.getProducts(this.selected_supplier.id)
            },
            getRefundDetailData: async function(supplier) {
                let that = this
                let param = {
                    start_at:  this.$bus.getYYYYMMDD(this.start_at, '-'),
                    end_at: this.$bus.getYYYYMMDD(this.end_at, '-'),
                    supplier_id: supplier.id,
                }
                
                console.log(this.selected_project)

                if (this.selected_project !== null) {
                    param['product_id'] = this.selected_project
                }

                let result = await apiGetCancelDetail(param).then(function(resp){
                    console.log(resp)
                    return resp.data
                }).catch(function(error){
                    return ''
                })

                if (result === '') {
                    return
                }

                result.data.chart_view.datasets.forEach(function(dataset,idx){
                    dataset['backgroundColor'] = that.chart_colors[idx]
                    dataset['borderColor'] = that.chart_colors[idx]
                })

                this.cancel_detail.chart_view = result.data.chart_view
                this.cancel_detail.table_view['items'] = result.data.table_view

                let total_view_keys = Object.keys(result.data.total_view)
                this.cancel_detail.total_view = []
                total_view_keys.forEach(function(key){
                    let tmp_total = {
                        "key": key,
                        "value": result.data.total_view[key]
                    }
                    that.cancel_detail.total_view.push(tmp_total)
                })
            },
            goScore: function(mode, item) {
                let score_url = new URL(window.location.protocol + '//' + window.location.host + '/user_score_manage')
                
                switch(mode) {
                    case 'admin':
                        score_url.searchParams.set('supplier_id', item.id);
                        break;
                    case 'supplier':
                        score_url.searchParams.set('supplier_id', this.selected_supplier.id);
                        score_url.searchParams.set('store_id', item.id);
                        break;
                    case 'store':
                        score_url.searchParams.set('supplier_id', this.selected_supplier.id);
                        score_url.searchParams.set('store_id', this.selected_store.id);
                        score_url.searchParams.set('product_id', item.id);
                        break;
                }
                score_url.searchParams.set('start_at', this.$bus.getYYYYMMDD(this.start_at, '-'));
                score_url.searchParams.set('end_at', this.$bus.getYYYYMMDD(this.end_at, '-'));

                window.open(score_url.href, '_blank').focus();
            },
            back: async function(back_tab) {
                console.log('back', back_tab)
                // if (this.merchant_session['is_super_manage'] === 0) {
                //     back_tab = 'store'
                // }
                let new_url = ''
                switch (back_tab) {
                    case 'admin':
                        console.log('1'); 
                        this.selected_project = null
                        this.selected_supplier = null
                        this.is_show_refund_detail = false
                        this.products = []
                        new_url = this.removeParamToUrl(window.location.href, 'supplier_id')
                        new_url = this.removeParamToUrl(new_url, 'store_id')
                        new_url = this.removeParamToUrl(new_url, 'product_id')
                        new_url = this.appendParamToUrl(new_url, 'report_type', 'sales')
                        break;

                    case 'supplier':
                        console.log('2');
                        new_url = this.removeParamToUrl(window.location.href, 'store_id')
                        new_url = this.removeParamToUrl(new_url, 'product_id')
                        console.log('back',new_url)
                        
                        break;

                    case 'store':

                        console.log("3");
                        console.log('back',new_url)
                        break;
                }
                window.history.pushState('', document.title, new_url);
                this.selected_store = null
                this.mode = back_tab
                await this.getData()
            },
            getOpenStatus: function(open_status) {
                return open_status ? '服務中' : '關閉中'
            },
            getSupplierNameById: async function(supplier_id) {
                let param = {
                    supplier_id: supplier_id
                }
                let result = await apiGetMerchantById(param).then(function(resp){
                    let data = resp.data
                    console.log(data)
                    return data.data.merchant_name
                }).catch(function(error){
                    console.log(error)
                    return '找不到此ID對應的供應商'
                })
                return result
            },
            getStoreNameById: async function(store_id) {
                let param = {
                    store_id: store_id
                }
                let result = await apiGetStoreById(param).then(function(resp){
                    let data = resp.data
                    console.log(data)
                    return data.data.name
                }).catch(function(error){
                    console.log(error)
                    return '找不到此ID對應的分店'
                })
                return result 
            }
        },
        created: async function() {
            let new_url = window.location.href
            let merchant_session = JSON.parse(localStorage.getItem('merchant_session'))
            switch (merchant_session['is_super_manage']) {
                case 0:
                    this.mode = 'store'
                    new_url = await this.appendParamToUrl(new_url, 'store_id', merchant_session['store_id'])
                    new_url = await this.appendParamToUrl(new_url, 'supplier_id', merchant_session['supplier_id'])
                    console.log(this.selected_store);
                    console.log(this.selected_supplier);
                    this.selected_store = {
                        id: await this.getQueryVariable('store_id'),
                        name: this.merchant_session['store_name']
                    }
                    break;

                case 1:
                    this.mode = 'supplier'
                    new_url = await this.appendParamToUrl(new_url, 'supplier_id', merchant_session['supplier_id'])
                    this.selected_supplier = {
                        id: this.merchant_session['supplier_id'],
                        name: this.merchant_session['merchant_name']
                    }
                    console.log(this.selected_supplier);
                    break;

                default:
                    break;
            }
            console.log(merchant_session);
            console.log('waht',this.getQueryVariable('report_type'))
            console.log('start_at_la',this.getQueryVariable('start_at'))
            console.log('end_at_la',this.getQueryVariable('end_at'))
            
            if (!this.getQueryVariable('report_type')) {
                new_url = this.appendParamToUrl(new_url, 'report_type', 'sales')
            }
            else {
                if (this.getQueryVariable('report_type') !== 'sales' && this.getQueryVariable('report_type') !== 'refund'){
                    new_url = this.appendParamToUrl(new_url, 'report_type', 'sales')
                }
            }

            if (this.getQueryVariable('start_at')) {
                new_url = this.appendParamToUrl(
                    new_url, 'start_at', this.$bus.getYYYYMMDD(new Date(this.getQueryVariable('start_at')), '-')
                )
                this.start_at = new Date(this.getQueryVariable('start_at'))
            }
            if (this.getQueryVariable('end_at')) {
                new_url = this.appendParamToUrl(
                    new_url, 'end_at', this.$bus.getYYYYMMDD(new Date(this.getQueryVariable('end_at')), '-')
                )
                this.end_at = new Date(this.getQueryVariable('end_at'))
            }

            window.history.pushState('', document.title, new_url);

            await this.getData()
        },
        mounted: async function() {

        }
    }

</script>
<style scoped>
.filter {
    display: flex;
    align-items: center;
}
.filter_container {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
}
.chart-container > div {
    height: 100%;
}
.open_status {
    background: #5cb85c;
    color: #FFF;
}
.status {
    padding: 5px 12px;
    border-radius: 5px;
}
.close_status {
    background: #cccccc;
    color: #777;
}
</style>